import React from 'react';

const SubmitButton = ({ label, onClick, type = "submit", disabled = false }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`bg-[#A1409D] text-white font-semibold p-[12px] rounded-full w-full mb-2 
                  hover:bg-[#7a2f78] focus:outline-none focus:bg-[#7a2f78] 
                  ${disabled ? 'disabled:opacity-50 disabled:pointer-events-none' : ''}`}
    >
      {label}
    </button>
  );
};

export default SubmitButton;
